import { render } from "./ActionAssignTaskEditor.vue?vue&type=template&id=5ed94202&scoped=true"
import script from "./ActionAssignTaskEditor.vue?vue&type=script&lang=js"
export * from "./ActionAssignTaskEditor.vue?vue&type=script&lang=js"

import "./ActionAssignTaskEditor.vue?vue&type=style&index=0&id=5ed94202&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed94202"]])

export default __exports__